import _ from 'lodash';
import React, { createRef } from 'react';
import autobind from 'autobind-decorator';
import { inject, observer } from 'mobx-react';

import FieldFactory from '../field-factory';
import PasswordInfo from './password-info';
import AgeInfo from './age-info';
import GenderSelect from './gender-select';
import FIELD_KEY_MAP from './field-key-map';
import ReactHintFactory from 'react-hint';
const ReactHint = ReactHintFactory(React);
import {UsaStates} from 'usa-states';

const stateList = new UsaStates().states.map(s=>{
	return {label: s.name, value: s.name};
});


@inject('genreStore', 'formStore')
@observer
class AccountCreationForm extends React.Component {
	constructor (props) {
		super(props);
		const {genreStore} = this.props;
		genreStore.fetchIfEmpty();
	}

	componentDidMount () {
		this.props.formStore.shouldStoreFormData = true;
		this.props.formStore.get(FIELD_KEY_MAP.location).options = stateList;

		document.addEventListener('keypress', this.onKeyPress);
	}

	componentWillUnmount () {
		document.removeEventListener('keypress', this.onKeyPress);
	}

	render () {
		const { user, artist, formStore, userStore, genreStore } = this.props;

		const Field = (props) => (
			<FieldFactory
				noFieldClass
				item={ user }
				store={ userStore }
				formStore={ formStore }
				onChange={ this.onChange }
				{ ...props }
			/>
		);

		return (
			<div className="grid-x padding-horizontal-1 margin-top-2">
				<ReactHint events={ { hover: true } } position="right" onRenderContent={(e) => this.renderPasswordReq(e)} persist />
				<div className="cell small-6" style={{display: "flex", flexDirection: "column"}}>
					<div className="grid-x grid-padding-x">
						<div className="cell small-6">
							<Field
								item={ user }
								fieldKey={ FIELD_KEY_MAP.firstName }
								placeholder="First Name"
								label='First Name'
							/>
						</div>
					</div>
					<div className="grid-x grid-padding-x">
						<div className="cell small-6">
							<Field
								item={ user }
								fieldKey={ FIELD_KEY_MAP.lastName }
								placeholder="Last Name"
								label='Last Name'
							/>
						</div>
					</div>

					<div style={{position:"relative"}}>
						<div className="grid-x align-middle" data-ta={ FIELD_KEY_MAP.dob }>
						<Field
								item={ user }
								fieldKey={ FIELD_KEY_MAP.dob }
								validate={this.validateAge}
								placeholder="Birthday (MM/DD/YYYY)"
								label='Birthday'
							/>
						</div>
						<AgeInfo user={user}/>
					</div>
					{/* <div className="grid-x grid-padding-x">
						<div className="cell small-6">
							<Field
								item={ user }
								fieldKey={ FIELD_KEY_MAP.phoneNumber }
								placeholder="Phone Number"
								label='Phone Number'
							/>
						</div>
					</div> */}
					
					{/* <div className="grid-x grid-padding-x margin-bottom-2">
						<div className="cell small-6">
						<Field
								item={ user }
								fieldKey={ FIELD_KEY_MAP.location }
								placeholder="Location"
								label='Location'
								dataId="location"
								onKeyup={(e) => {console.log(e)}}
							/>
						</div>
					</div> */}

					<GenderSelect user={user} onChange={(gender)=>{user.gender = gender; this.onChange(FIELD_KEY_MAP.gender, gender)}} />
					
				</div>
				<div className="cell small-6" style={{display: "flex", flexDirection: "column"}}>

					<div className="grid-x grid-padding-x">
						<div className="cell small-6">
							<Field
								item={ artist }
								fieldKey={ FIELD_KEY_MAP.name }
								placeholder="Artist/Band Name"
								label='Artist/Band Name'
							/>
						</div>
					</div>
					<div className="grid-x grid-padding-x margin-bottom-2">
						<div className="cell small-6" data-ta="genreSelect">
							<Field
								item={ artist }
								optionsStore={ genreStore }
								fieldKey={ FIELD_KEY_MAP.genre }
								placeholder="Select Genre"
								label='Genre'
							/>
						</div>
					</div>
					<div className="grid-x grid-padding-x">
						<div className="cell small-6">
							<Field
								item={ user }
								fieldKey={ FIELD_KEY_MAP.email }
								placeholder="Email"
								label='Email'
							/>
						</div>
					</div>

					{/* <div className="grid-x grid-padding-x">
						<div className="cell small-6">
							<Field
								item={ artist }
								fieldKey={ FIELD_KEY_MAP.paymentServiceID }
								placeholder="Stripe Email Address"
								label=''
							/>
						</div>
					</div>
					<div className="grid-x grid-padding-x">
						<div className="cell small-12">
							<p>
								<a href="https://dashboard.stripe.com/register" target="_blank">
									Click here to create your free Stripe account.
								</a>
							</p>
						</div>
					</div> */}

					<div style={{position:"relative", maxWidth:"18vw"}}>
						<div className="grid-x align-middle">
							<Field 
								fieldKey={ FIELD_KEY_MAP.password }
								placeholder='Password'
								changeOnBlur={false}
								changeOnKeyUp={true}
								label='Password'
							/>
						</div>
						<PasswordInfo isPasswordBox={true} />
					</div>
					<div style={{position:"relative", maxWidth:"18vw"}}>
						<div className="grid-x align-middle">
							<Field
								fieldKey={ FIELD_KEY_MAP.confirmPassword }
								validate={ this.validateConfirmPassword }
								placeholder='Confirm Password'
								label='Confirm Password'
								changeOnBlur={false}
								changeOnKeyUp={true}
							/>
						</div>
						<PasswordInfo isPasswordBox={false} />
					</div>
					
					
				</div>
			</div>
		);
	}

	@autobind
	renderPasswordReq (e) {
		let defaultRh = e.getAttribute('data-rh')

		if(defaultRh.length > 0) {
			return (
				<div style={{width:'25vw',
					textAlign:'left', 
					boxShadow:`6px 6px 13px -3px #000000`, padding: '0.5vw',
					backgroundColor: "#381648"}}>
					{defaultRh}
				</div>
			)
		}
		return (
			<div style={{width:'25vw',
				textAlign:'left', 
				boxShadow:`6px 6px 13px -3px #000000`, padding: '0.5vw',
				backgroundColor: "#381648"}}>
				Your password must:<br/>
				<ul style={{listStyleType:'none'}}>
					<li>Be at least 8 characters long</li>
					<li>Contain at least one uppercase letter</li>
					<li>Contain at least one number</li>
					<li>Contain at least one special character</li>
					<li>Not contain sequences of three or more repeated characters</li>
				</ul>
			</div>
		)

	}

	@autobind
	validateAge (value) {
		const { formStore } = this.props;
		return formStore.validate(value, FIELD_KEY_MAP.dob);
	}

	@autobind
	validateConfirmPassword (confirmPassword, key) {
		const { formStore, user: { password } } = this.props;
		const value = {
			password,
			confirmPassword
		};

		return formStore.validate(value, key);
	}

	@autobind
	onChange (key, value) {
		const { props, user, artist, formStore } = this.props;
		const isValid = formStore.validateFields(_.values(FIELD_KEY_MAP), (key) => {
			const item = (/^user/).test(key) ? user : artist;
			const value = item[key.replace(/^.+\./, '')];
			if (key === FIELD_KEY_MAP.confirmPassword) {

				return {
					confirmPassword: value,
					password: user.password
				};
			}

			return value;
		});

		formStore.validation = {
			accountCreationForm: isValid
		};

		if (key === FIELD_KEY_MAP.dob) {
			user.dob = value;
		}

		if (key === FIELD_KEY_MAP.email) {

			user.userName = value;
		}
		if (key === FIELD_KEY_MAP.gender) {
			user.gender = value;
		}
	}
}

export default AccountCreationForm;
